import React from 'react';
import { useEffect, useState } from "react"
import { Modal, Table, Button, Space, Typography, Tag, Dropdown, Spin, Popconfirm } from 'antd';
import { CloseOutlined, DownOutlined } from '@ant-design/icons';
import PropTypes from "prop-types" // Import PropTypes
import { deleteBill, getBills } from '../../services/doctor/bills/bills';
import dayjs from "dayjs";
import {onShowSizeChange,itemRender}from  '../Pagination'
import { Link } from "react-router-dom";
import CreateBillModal from "./Itemized-bill-modal";
import { useMessageApi } from '../../services/message api/MessageProvider';
import { handlePrint, isIpadSafari, testPopup } from './PrintBillSetting';
import { executeBrowserPrint } from './printService';

const { Title, Text } = Typography;

const BillingHistoryModal = ({ visible, onClose, patientData }) => {

  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [billingHistory, setBillingHistory] = useState([]);
  const [isCreateBillOpen, setIsCreateBillOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [editBillData, setEditBillData] = useState("");
  const messageApi = useMessageApi();


  const fetchBillingHistory = async () => {
    try {
      setLoading(true);
      const result = await getBills(searchKeyword, '', patientData?.id);
      if (result.success) {
        console.log('Billing History data:', result.data);
        setBillingHistory(result.data);
        setLoading(false);
      } else {
        // Optionally handle error
        setBillingHistory([]);
      }
    } catch (err) {
      // Optionally handle error
      setBillingHistory([]);
    }
  };

  const handleDelete = async(id) => {
    try {
          setLoading(true);
          const result = await deleteBill(id);
          if (result?.success) {
            messageApi.open({
              type: "success",
              content: "Bill deleted successfully!",
            });
            // Refresh the billing history
            setLoading(false);
            fetchBillingHistory();
          } else {
            messageApi.error(result.error || "Failed to delete bill");
            setLoading(false);
          }
        } catch (err) {
          messageApi.error(err.message || "Error deleting bill");
          setLoading(false);
        }
  }
    
  useEffect(()=>{
    if( visible )
    {
      fetchBillingHistory();
    }
  },[visible, refresh]);

  // Column definitions based on the image
  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      render: (text, record) => (
        <>{dayjs(record.created_at).format("DD MMM YYYY")}</>
      ),
    },
    {
      title: "No. of Edits",
      dataIndex: "edits",
      render: (text, record) => `${record.number_of_edits}`,
    },
    {
      title: "Bill No.",
      dataIndex: "billNo",
      key: "billNo",
      render: (text, record) => (
        <Link to="#" onClick={() => {}}>
          {record.doctor_bill_no}
        </Link>
      ),
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
      key: "billAmount",
      render: (text, record) => `₹${record.payment_amount}`,
    },
    {
      title: "Payment Mode",
      dataIndex: "paymentMode",
      key: "amountPaid",
      render: (text, record) => `${record.payment_mode}`,
    },
    {
      title: "Action", // Added a title for clarity
      key: "action",
      render: (text, record) => {
        const items = [
          {
            key: "1",
            label: "Edit",
            onClick: () => {
              setisEdit(true);
              setEditBillData(record);
              setIsCreateBillOpen(true);
            },
          },
          {
            key: "3",
            label: (
              
                <span >Print</span>
            ),
            onClick : () => {
                try {
                  if (record.print_html_view) {
                    // If the HTML was already saved to DB, use it directly
                    executeBrowserPrint(record.print_html_view);
                  } else {
                    // Fallback: If no HTML saved, show a message or trigger a re-generation logic
                    messageApi.info("Generating print view...");
                    // You could technically open the Edit modal in "hidden" mode
                    // or trigger a logic to build the HTML here.
                  }
                } catch (err) {
                  console.error("Print failed:", err);
                }
              }
          },
          {
            key: "2",
            danger: true, // Makes the text red
            label: (
              <Popconfirm
                title="Delete this bill?"
                description="Are you sure you want to delete this record?"
                onConfirm={() => handleDelete(record.id)} // Replace with your actual delete logic
                okText="Yes"
                cancelText="No"
              >
                <span>Delete</span>
              </Popconfirm>
            ),
          },
          
        ];

        return (
          <Dropdown menu={{ items }} trigger={["click"]}>
            <a
              onClick={(e) => e.preventDefault()}
              style={{ cursor: "pointer" }}
            >
              <Space>
                Actions
                <DownOutlined style={{ fontSize: "10px" }} />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  // Sample data from the image
  /*const data = [
    { key: '1', date: '20 Jan 2026', edits: 0, billNo: 'SRH/2025-2026/1000017', billAmount: 400, amountPaid: 200 },
    { key: '2', date: '20 Jan 2026', edits: 0, billNo: 'SRH/2025-2026/1000015', billAmount: 200, amountPaid: 200 },
    { key: '3', date: '20 Jan 2026', edits: 0, billNo: 'SRH/2025-2026/1000014', billAmount: 800, amountPaid: 600 },
  ];*/

  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={null}
        width={1200}
        closable={false} // Custom header close button
        bodyStyle={{ padding: 0 }}
      >
        {/* Top Patient Header Bar */}
        <div style={{ 
          padding: '12px 24px', 
          borderBottom: '1px solid #f0f0f0', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          <div>
            <Title level={5} style={{ margin: 0 }}>{patientData?.full_name}</Title>
            <Text type="secondary" style={{ fontSize: '12px' }}>{patientData?.gender}, {patientData?.age}</Text>
          </div>
          <Button icon={<CloseOutlined />} onClick={onClose}>Close</Button>
        </div>

        {/* Main Content Area */}
        <div style={{ padding: '24px 40px' }}>
          {/* Billing History Title and Actions */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <Title level={3} style={{ margin: 0 }}>Billing History</Title>
            
            <Space size="middle">
              {/* <div style={{ marginRight: 20 }}>
                <Text strong style={{ fontSize: '24px' }}>Due ₹200</Text>
              </div>
              <Button size="large">Refund</Button> */}
              <Button type="primary" size="large" onClick={() => { setIsCreateBillOpen(true), setisEdit(false), setEditBillData("") }} style={{ backgroundColor: '#1890ff' }}>
                Add Bill / Payment
              </Button>
            </Space>
          </div>

          {/* Table Section */}
          {loading ? (
            <div className="w-100 p-4 d-flex align-items-center justify-content-center">
              <Spin size="large" />
            </div>
          ) : (
            <Table 
              columns={columns} 
              dataSource={billingHistory} 
              //pagination={{ position: ['bottomCenter'], current: 1, total: 1 }}
              pagination={{
                total: billingHistory.length,
                showTotal: (total, range) => (`Showing ${range[0]} to ${range[1]} of ${total} entries`),
                itemRender: itemRender,
              }}
              rowClassName={() => 'billing-row'}
            />
          )}
        </div>
      </Modal>
      
      <CreateBillModal patientData={patientData} isOpen={isCreateBillOpen} onClose={() => setIsCreateBillOpen(false)} refresh={() => setRefresh(!refresh)} isedit={isEdit} editBillData={editBillData} />
    </>
  );
};

export default BillingHistoryModal;
BillingHistoryModal.propTypes = {
    visible: PropTypes.bool.isRequired, // isOpen must be a boolean and is required
    onClose: PropTypes.func.isRequired, // onClose must be a function and is required
    patientData: PropTypes.patientData,
  }